import { render, staticRenderFns } from "./ProductManagementModal.vue?vue&type=template&id=58324f18&scoped=true"
import script from "./ProductManagementModal.vue?vue&type=script&lang=js"
export * from "./ProductManagementModal.vue?vue&type=script&lang=js"
import style0 from "./ProductManagementModal.vue?vue&type=style&index=0&id=58324f18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58324f18",
  null
  
)

export default component.exports